export const fr = {
  videoQualityPresets: "Presets",
  prods: "Prods",
  stayInformed: "Restez informé",
  email: "E-mail",
  send: "Envoyer",
  backToHome: "← Retour à l'accueil",
  copyright: "© Hickssama 2021-2025 || support@hickssama.com",
  language: "Langue",
  english: "Anglais",
  french: "Français",
  introGreeting: "Salut, moi c’est Hickssama. Bienvenue sur mon site !",
  introProfileAlt: "Ma photo de profil",
  introPresetsDesc: "Tu peux retrouver ici mes presets pour réaliser des vidéos et edits avec la même qualité et les mêmes effets que moi.",
  introProdsDesc: "Tu trouveras aussi certaines de mes prods, utilisées dans mes vidéos.",
  followMe: "Suis-moi sur les réseaux si ce n’est pas déjà fait, et inscris-toi à la mailing list pour ne rien rater. Tu peux aussi me contacter sur Instagram ou par mail à support@hickssama.com.",
  termsOfService: "Conditions",
  privacyPolicy: "Confidentialité"
};
